<script setup lang="ts">
import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

const props = defineProps<{
  data: SectionHomeRecord
  moduleIndex: number
}>()

const { level, isSemantic, invertedStyles } = useSectionRules(
  props.moduleIndex,
  props.data.invertColorTheme
)

const appConfig = useAppConfig()
const isDifference = ref(false)
const ctxRef = ref<HTMLElement | null>(null)

let ctx: gsap.Context | null = null

const isIntroScene = useState('intro')
isIntroScene.value = true
const isVideoVisible = ref(false)

onMounted(() => {
  if (ctxRef.value) {
    gsap.registerPlugin(ScrollTrigger)

    ctx = gsap.context(() => {
      ScrollTrigger.create({
        trigger: '#home-content-scroll',
        start: 'top bottom',
        markers: false,
        onEnter: () => {
          isDifference.value = true
        },
        onEnterBack: () => {
          isDifference.value = true
        }
      })

      ScrollTrigger.refresh()
      ScrollTrigger.sort()
    }, ctxRef.value as HTMLElement)
  }
})

onUnmounted(() => {
  if (ctx) {
    ctx.revert()
    isIntroScene.value = false
  }
})
</script>

<template>
  <div id="home" ref="ctxRef" class="bg-white pb-[50vh] pt-[200vh] lg:pb-0">
    <div
      id="home-fixed-wrapper"
      class="pointer-events-none fixed left-0 top-0 h-screen w-full lg:z-[1]"
    >
      <CanvasRocket :enabled="appConfig.ui.enable3D" />
      <SectionHomeContent
        :data="data"
        :module-index="moduleIndex"
        :level="level"
        :is-semantic="isSemantic"
        :inverted-styles="invertedStyles"
        class="pointer-events-auto"
        :class="{
          'text-white mix-blend-difference': !isDifference
        }"
        @on-click="isVideoVisible = true"
      />
      <!-- <LazyAltiMeter /> -->
      <ScrollDown align="center" color="black" />
    </div>
    <div
      id="home-content-scroll"
      class="dummy-holder pointer-events-none relative h-screen bg-transparent lg:bg-white"
    ></div>
    <Transition name="videoOverlay">
      <VideoFullScreen
        v-if="isVideoVisible"
        :options="{
          controls: true,
          autoplay: true,
          preload: 'metadata',
          sources: [
            {
              src: data.reel?.video?.video?.streamingUrl ?? '',
              type: 'application/x-mpegURL'
            }
          ],
          fill: true,
          bigPlayButton: false,
          controlBar: {
            volumePanel: false,
            playToggle: false,
            fullscreenToggle: false,
            pictureInPictureToggle: false,
            currentTimeDisplay: false,
            remainingTimeDisplay: false
          }
        }"
        @on-close="isVideoVisible = false"
      />
    </Transition>
  </div>
</template>
